<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" @opened="openFun">
    <el-form :model="userForm" :rules="rules" ref="userRef" label-width="120px">
      <el-form-item v-show="false" prop="id">
        <el-input v-model="userForm.id"></el-input>
      </el-form-item>
      <el-form-item label="账号" prop="username">
        <el-input v-model="userForm.username" :disabled="isDisabled" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="昵称" prop="nickName">
        <el-input v-model="userForm.nickName" placeholder="请输入昵称"></el-input>
      </el-form-item>
      <el-form-item label="用户角色" prop="roleIds">
        <el-select v-model="userForm.roleIds" multiple placeholder="请选择角色">
          <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName"
                     :value="parseInt(item.id)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属部门" prop="positionsId">
        <el-cascader
            v-model="selectPositions"
            :options="options"
            :props="{ checkStrictly: true , expandTrigger: 'hover',  value: 'id', label: 'name', children: 'children' }"
            placeholder="所属部门"
            clearable
        ></el-cascader>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="resetUserForm('userRef')">重置</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitUser('userRef')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {editUser} from "../../../api/sys/user/sysUser";
import {getRoleList} from "../../../api/sys/role/sysRole";
import {getPositionsTree} from "../../../api/sys/positions/sysPositions";
import {successMsg} from "../../../utils/message";

export default {
  name: "editUser",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    userObj: Object
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    },
    isDisabled: {
      get: function () {
        return !!this.userObj.id
      }
    }
  },
  data() {
    return {
      title: '新增',
      isLoading: false,
      userForm: {
        id: null,
        username: '',
        nickName: '',
        roleIds: [],
        positionsId: ""
      },
      rules: {
        username: [{required: true, message: '用户名不能为空', trigger: 'blur'}],
        nickName: [{required: true, message: '用户昵称不能为空', trigger: 'blur'}],
        roleIds: [{required: true, message: '用户角色不能为空', trigger: 'blur'}],
        positionsId: [{required: true, message: '用户部门不能为空', trigger: 'blur'}]
      },
      selectPositions: [],
      roleList: [],
      options: []
    }
  },
  mounted() {
    this.getRoleList()
    this.getPositionsList()
  },
  methods: {
    resetUserForm(ref) {
      this.$refs[ref].resetFields();
    },
    openFun: function () {
      this.title = this.userObj.id ? '编辑' : "新增";
      // 逐个属性赋值给 userForm
      this.userForm.id = this.userObj.id || null;
      this.userForm.username = this.userObj.username || '';
      this.userForm.nickName = this.userObj.nickName || '';
      this.userForm.positionsId = this.userObj.positionsId || '';
      //  将roleIds中的字符串数字转化为数字
      this.userForm.roleIds = this.userObj.roleIds ? this.userObj.roleIds[0].split(',').map(Number) : [];
      const path = this.findNodePath(this.options, this.userObj.positionsId)
      this.selectPositions = [];
      path.filter(item => this.selectPositions.push(item.id));
    },
    getPositionsList() {
      getPositionsTree({}).then(res => {
        this.options = res;
      })
    },
    //  获取角色列表
    getRoleList() {
      getRoleList({}).then(res => {
        this.roleList = res
      })
    },
    handleChange(val) {
      console.log(val);
    },
    //  提交
    submitUser(formName) {
      this.userForm.positionsId = this.selectPositions[this.selectPositions.length - 1];
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          editUser(this.userForm).then(() => {
            successMsg('操作成功')
            this.visible = false
            this.$emit('get-list')
          }).finally(() => {
            this.isLoading = false;
          });
        }
      })
    },
    findNodePath(treeData, targetId) {
      const traverse = (nodes, targetId, path = []) => {
        for (const node of nodes) {
          const currentPath = [...path, node]

          // 找到目标节点时返回完整路径
          if (node.id === targetId) return currentPath

          // 递归子节点
          if (node.children) {
            const found = traverse(node.children, targetId, currentPath)
            if (found) return found
          }
        }
        return null
      }
      return traverse(treeData, targetId) || []
    }
  }
}
</script>

<style scoped>
::v-deep .vue-treeselect__control {
  height: 28px;
}
.el-select {
  width: 100%;
}

::v-deep .el-form-item__content {
  line-height: 28px;
  font-size: 12px;
}
</style>